import { render } from "./AreaPage.vue?vue&type=template&id=7a2a62cb&scoped=true"
import script from "./AreaPage.vue?vue&type=script&lang=js"
export * from "./AreaPage.vue?vue&type=script&lang=js"

import "./AreaPage.vue?vue&type=style&index=0&id=7a2a62cb&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2a62cb"]])

export default __exports__